<template>
  <div data-id-e2e="activeBundles" class="w-100">
    <WorkpackagesToolbar
      doc-path="190-bundles"
      :entity="entities.bundle"
      @on-search="onSearch"
      @on-sort="onSort"
    />

    <v-card class="col-box">
      <v-alert
        v-if="bundlesStore.loading"
        border="start"
        border-color="primary-accent-4"
        color="primary-accent-4"
        variant="tonal"
      >
        <v-progress-circular indeterminate color="primary" size="20" />
        {{ tkey('loadingActiveBundles') }}
      </v-alert>
      <v-row no-gutters>
        <v-col class="bundles__container">
          <WorkpackagesList
            v-if="sortedBundlesList.length"
            :entity="entities.bundle"
            :visible-workpackages="visibleBundles"
            :workpackages="sortedBundlesList"
          />
          <v-alert
            v-if="!bundlesStore.loading && !visibleBundles.length"
            type="info"
            variant="tonal"
          >
            {{ tkey('noActiveBundles') }}
          </v-alert>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import entities from '@enums/entities';
import sortUtils from '@/utils/sort-utils';
import searchUtils from '@/utils/search-utils';
import { useInternationalization } from '@/composables/use-internationalization';
import { useBundlesStore } from '@/stores/bundles';

export default {
  setup() {
    const bundlesStore = useBundlesStore();
    const { tkey } = useInternationalization('bundlesPage');
    return { bundlesStore, tkey };
  },

  data() {
    return {
      sortOrder: null,
      searchText: '',
      entities,
    };
  },

  computed: {
    visibleBundles() {
      return searchUtils.getResultsByNameDescription(
        this.searchText,
        this.bundlesStore.bundles,
        this.sortOrder
      );
    },

    sortedBundlesList() {
      return this.sortOrder
        ? sortUtils.sortItemList(this.bundlesStore.bundles, this.sortOrder)
        : this.bundlesStore.bundles;
    },
  },

  async created() {
    // initialise getting all bundles
    await this.bundlesStore.fetchBundles();
  },

  methods: {
    onSort(sortOrder) {
      this.sortOrder = sortOrder;
    },

    onSearch(searchText) {
      this.searchText = searchText;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@style/base/_variables.scss';

.bundles {
  &__container {
    overflow-x: auto;
  }
}

:deep(.progress-bar) {
  padding-bottom: 10em;
}
</style>
